import { render, staticRenderFns } from "./SingleAttachment.vue?vue&type=template&id=5384c32a"
import script from "./SingleAttachment.vue?vue&type=script&lang=js"
export * from "./SingleAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports